import { render } from "./MyId.vue?vue&type=template&id=6e34b440"
import script from "./MyId.vue?vue&type=script&lang=js"
export * from "./MyId.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroWeb\\marriage_beauro_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__